module.exports = __webpack_public_path__ + "static/us_california_green-58990161a97fb243be70babf3d63a87c.png";